import useScrollReveal from '@/hooks/useScrollReveal';
import SiteHeader from './components/SiteHeader';
import HeroSection from './components/HeroSection';
import HotRankingSection from './components/HotRankingSection';
import LatestCasesSection from './components/LatestCasesSection';
import TimelineSection from './components/TimelineSection';
import ResponsesSection from './components/ResponsesSection';
import VerdictSection from './components/VerdictSection';
import CollectionsSection from './components/CollectionsSection';
import GuideSection from './components/GuideSection';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  useScrollReveal();

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <HeroSection />
        <HotRankingSection />
        <LatestCasesSection />
        <TimelineSection />
        <ResponsesSection />
        <VerdictSection />
        <CollectionsSection />
        <GuideSection />
      </main>
      <SiteFooter />
    </div>
  );
}